export default "__VITE_ASSET__BW8P2ND7__"